import type { BotState, FormState } from '../types';

export const handleRecaptchaRender = <T extends string>(
  promise: Promise<any>,
  setFormState: React.Dispatch<React.SetStateAction<FormState<T>>>,
  formSubmitted: boolean | undefined,
  formLoading: boolean | undefined,
  setBotState: React.Dispatch<React.SetStateAction<BotState>>,
  isBotCheckDone?: boolean,
) => {
  promise
    .then(() => {
      setBotState({
        isBotCheckDone,
        isRenderRecaptchaStarted: true,
        isRenderRecaptchaDone: true,
      });
    })
    .catch((error: any) => {
      setFormState({
        submitted: formSubmitted,
        loading: formLoading,
        error: error.message || error,
      });
    });
};
